import React from "react";

export const Spinner = () => {
  return (

    <div className="flex justify-center items-center w-5 h-5 bg-transparent rounded-full">
      <div className="w-5 h-5 border-4 border-white border-t-transparent rounded-full animate-spin"></div>

    </div>
  );
};
